module.exports = __webpack_public_path__ + "img/img-org.2c867f46.png";